var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.05 31.05",
    style: {
      enableBackground: "new 0 0 31.05 31.05"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#E48B53;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,11.54h2.97v9.54H8.6V11.54z M10.09,6.8c0.95,0,1.72,0.77,1.72,1.72c0,0.95-0.77,1.72-1.72,1.72 c-0.95,0-1.72-0.77-1.72-1.72C8.37,7.57,9.14,6.8,10.09,6.8 M13.43,21.08h2.96v-4.72c0-1.24,0.24-2.45,1.78-2.45 c1.52,0,1.54,1.42,1.54,2.53v4.64h2.96v-5.23c0-2.57-0.55-4.54-3.56-4.54c-1.44,0-2.41,0.79-2.81,1.54h-0.04v-1.31h-2.84V21.08z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.52,0C6.96,0,0,6.96,0,15.53c0,8.56,6.96,15.53,15.53,15.53s15.53-6.96,15.53-15.53 C31.05,6.96,24.09,0,15.52,0z M15.52,29.06c-7.46,0-13.53-6.07-13.53-13.53c0-7.46,6.07-13.53,13.53-13.53 c7.46,0,13.53,6.07,13.53,13.53C29.06,22.99,22.99,29.06,15.52,29.06z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinIcon);
export default __webpack_public_path__ + "static/media/linkedin_icon.ee6537fb102b58dc90e22706d128d40f.svg";
export { ForwardRef as ReactComponent };